import _ from 'lodash';
import { getFormValues } from 'redux-form';

export function getProps(object) {
    let props = [];
    for (const key in object) {
        if (object.hasOwnProperty(key)) {
            props.push(object[key]);
        }
    }

    return props;
}

export function getKeys(object, valueFilter) {
    let keys = [];
    if (!object) {
        return keys;
    }

    for (const key in object) {
        if (object.hasOwnProperty(key)) {
            if (valueFilter && !valueFilter(object[key])) {
                continue;
            }

            keys.push(key);
        }
    }

    return keys;
}

export function clone(object) {
    return JSON.parse(JSON.stringify(object));
}

export function getFileType(document) {
    const { content_type, filename } = document;
    if (!content_type || content_type === '') {
        return undefined;
    }

    let parts = content_type.split('/');
    if (parts.length !== 2) {
        return parts[0];
    }

    if (parts[1].indexOf('spreadsheet') > 0 && filename.indexOf('.') > 0) {
        let nameParts = filename.split('.');
        return nameParts[nameParts.length - 1];
    }

    return parts[1];
}

export function getFileSize(size) {
    var e = (Math.log(size) / Math.log(1e3)) | 0;
    return +(size / Math.pow(1e3, e)).toFixed(2) + ' ' + ('kMGTPEZY'[e - 1] || '') + 'B';
}

export function makeIntArray(size, start) {
    let array = Array.apply(null, { length: size }).map(Number.call, Number);
    return array.map(a => a + start);
}

export function anythingChanged({ initialValues, formName, state, values }) {
    const formValues = values || getFormValues(formName)(state);
    const result = _.isEqualWith(initialValues, formValues, (old, current) => {
        const falsy = ['', null, undefined];
        const isOldF = falsy.includes(old);
        const isCurrentF = falsy.includes(current);

        if (isOldF && isCurrentF) {
            return true;
        }

        return undefined;
    });
    return result;
}



// WEBPACK FOOTER //
// ./src/utilities/common.jsx